<template>
  <div
    :class="
      'absolute border-[1px] px-3 py-3 rounded-md transition-colors cursor-pointer ' +
      positionClass + ' ' + colorClass.containerClass
    "
    @click="copyToClipboard()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        :fill="colorClass.iconFill"
        d="M11.4 0a.85.85 0 0 1 .622.273l2.743 3a.884.884 0 0 1 .235.602v9.25a.867.867 0 0 1-.857.875H3.857A.867.867 0 0 1 3 13.125V.875C3 .392 3.384 0 3.857 0zM14 4h-2.6a.4.4 0 0 1-.4-.4V1H4v12h10z"
      />
      <path
        :fill="colorClass.iconFill"
        d="M3 1H2a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1h-1v1H2V2h1z"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { useToast } from "primevue/usetoast";
import { Ref } from "vue";

const colorClasses = {
  dark: {
    containerClass: 'border-slate-800 hover:bg-gray-400',
    iconFill: 'black',
  },
  light: {
    containerClass: 'border-gray-100 hover:bg-gray-600',
    iconFill: 'white',
  },
}

const props = defineProps<{
  container: Ref<HTMLElement | HTMLInputElement | undefined>;
  positionClass?: string;
  color?: string
}>();

const positionClass = props.positionClass ?? "top-2 right-2";
const colorClass = props.color ? colorClasses[props.color] : colorClasses.light;
const toast = useToast();

const copyToClipboard = () => {
  const container = props.container;

  if (typeof container == undefined) {
    console.error("You must provide an element to copy it's content.");
    return;
  }

  let content = "";
  // Here we must use type narrowing to avoid typescript errors
  if (container instanceof HTMLInputElement) {
    content = container.value;
  } else if (container instanceof HTMLElement) {
    content = container.innerText;
  }

  navigator.clipboard
    .writeText(content)
    .then(() => {
      toast.add({
        severity: "success",
        summary: "Succès",
        detail: "Le contenu a été copié dans le presse-papier.",
        life: 2000,
      });
    })
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};
</script>